import React from 'react';
import { Box, makeStyles, Typography } from "@material-ui/core";
import EmergencyIcon from '../icons/EmergencyIcon';
import BotaoImprimirNotaFiscal from './BotaoImprimirNotaFiscal';
import consts from '../../../main/consts';
import { sendGaEvent } from '../../../main/sendGaEvent';
import alertaStyles from './Alerta.styles';
import { BotaoImprimirFormulario } from './BotaoImprimirFormulario';

const useStyles = makeStyles((theme) => ({
  ...alertaStyles,
  alertBox: {
    ...alertaStyles.alertBox,
    flexDirection: 'column',
  },
  alertBoxHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    gap: '1rem',
    paddingRight: '1rem',
  },
  alertBoxBottom: {
    display: 'flex',
    justifyContent: 'right',
    paddingRight: '1rem',
  },
}));

function AlertaCodigoRetiradaModal({ canalDeVendas, notaFiscal, idPedido, printRef, newPrintReceipt }) {
  const classes = useStyles();

  const imprimirNotaFiscal = (notaFiscal) => {
    const nfUrl = consts.NOTA_FISCAL_URL + notaFiscal.chave;

    window.open(nfUrl, '_blank');

    sendGaEvent('preview_invoice', 'ready-to-go', {
      sales_channel: canalDeVendas,
      order_id: idPedido,
      origin: 'codigo-retirada'
    })
  }

  return (
    <Box className={classes.alertBox}>
      <Box className={classes.alertBoxHeader}>
        <EmergencyIcon />
        <Box display={'flex'} flexDirection={'column'} flex={1}>
          <Typography variant="inherit" className={classes.alertTitle}>
            Lembre-se
          </Typography>
          <Typography variant="caption" className={classes.alertSubtitle}>
            {newPrintReceipt
              ? <>
                <strong>Confira se o formulário do pedido foi colocado junto ao pacote</strong> para que o
                cliente possa consultar a nota fiscal via QR Code.
              </>
              : <>
                Pedidos com canal de venda <strong>{canalDeVendas}</strong>, é <strong>obrigatório</strong> imprimir e <br />
                enviar a nota fiscal para o cliente.
              </>
            }
          </Typography>
        </Box>
      </Box>
      <Box className={classes.alertBoxBottom}>
        {newPrintReceipt
          ? <BotaoImprimirFormulario printRef={printRef} />
          : <BotaoImprimirNotaFiscal disabled={!notaFiscal} variant="text" onClick={() => imprimirNotaFiscal(notaFiscal)} />
        }
      </Box>
    </Box>
  )
}

export default AlertaCodigoRetiradaModal;